import React from "react";
import { connect } from "react-redux";
import { Actions as GROUPACTIONS } from "../../../store/actions/groupActions";
import { XMarkIcon } from "@heroicons/react/20/solid";
import AddGroupModal from "./AddGroupModal";

const AddGroup = ({ setOpenModal, modalState, modalGroup }) => {
	if (!modalState) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{
				display: "block",
				background: "rgba(0,0,0,0.4)",
				overflow: "auto",
			}}
		>
			<div
				className="modal-dialog"
				style={{ width: "65%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={setOpenModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">{modalGroup ? "Edit" : "Add"} Group</h3>
						</div>
						<div
							className="block-content"
							style={{ paddingRight: 0, paddingTop: 0, paddingBottom: 15 }}
						>
							<div
								className="tab-pane active pr-0"
								style={{ paddingLeft: 25 }}
								id="btabs-alt-static-justified-general"
							>
								<AddGroupModal />
								<div className="clearfix" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		modalState: state?.pensions?.group?.modalState,
		modalGroup: state?.pensions?.group?.modalGroup ? true : false,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setOpenModal: () => dispatch(GROUPACTIONS.setOpenModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddGroup);
